import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss',
})
export class Navbar {
  @Input() currentView: 'home' | 'bookings' | 'transactions' | 'checkout' | 'validate-qr' | 'profile' = 'home';
  @Input() cartQuantity: number = 0;
  @Input() userName: string = '';
  @Input() organisationName: string = '';

  @Output() onViewChange = new EventEmitter<'home' | 'bookings' | 'transactions' | 'validate-qr' | 'profile'>();
  @Output() onCartToggle = new EventEmitter<boolean>();
  @Output() logout = new EventEmitter<void>();

  mobileMenuOpen: boolean = false;

  get initials(): string {
    if (!this.userName) return '--';
    const parts = this.userName.trim().split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return parts[0].substring(0, 2).toUpperCase();
  }

  switchView(view: 'home' | 'bookings' | 'transactions' | 'validate-qr' | 'profile') {
    this.onViewChange.emit(view);
    this.mobileMenuOpen = false;
  }

  toggleCart() {
    this.onCartToggle.emit(true);
  }
}
